<template>
  <v-container class="mx-2 ma-sm-12" fluid>
    <div class="text-h5 font-weight-black _light_grey--text">{{ $t('downloadZone') }}</div>
    <v-tabs class="my-2 my-sm-12" background-color="rgba(0,49,101,0.75)" dark>
      <v-tab class="text-body-2" v-for="category in noticesCategory" :key="category" :href="`#${category}`">{{ $t(category) }}</v-tab>
      <v-spacer />
      <v-tab-item v-for="page in noticesCategory" :key="page" :value="page">
        <v-card flat height="190px" color="rgba(195,195,195,0.5)" class="card_scroll">
          <v-card-text>
            <ul v-for="(notice, j) in showNotices" :key="'page_' + j" v-show="notice.category === page" @click="showDetailHandler(notice)">
              <li>
                <a class="_blue--text darken-4">{{ new Date(notice.updateTime).toLocaleDateString() }} {{ notice.name }}</a>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <v-simple-table class="transparent mb-5" v-for="category in downloadCategory" :key="category">
      <template v-slot:default>
        <thead class="dt_bg_blueTrans">
          <tr>
            <th scope="col" class="text-body-2 text-left white--text" width="30%">{{ $t('download') }} - {{ $t(category) }}</th>
            <th scope="col" class="text-body-2 text-left white--text" width="50%">{{ $t('description') }}</th>
            <th scope="col" class="text-body-2 text-left white--text" width="10%">{{ $t('updateDate') }}</th>
            <th scope="col" class="text-body-2 text-left white--text text-right">{{ $t('download') }}</th>
          </tr>
        </thead>
        <tbody class="dt_bg_transparent">
          <tr v-for="item in downloadCategoryFiles(category)" :key="item.id">
            <td class="dt_Content">{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ new Date(item.updateTime).toLocaleDateString() }}</td>
            <td class="text-right">
              <v-btn icon @click="downloadHandler(item.filePath)" :key="item.id">
                <v-icon color="_blue">mdi-download</v-icon>
                <span style="font-size: 0rem">{{ $t('download') }}</span>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog v-model="hasDetail" max-width="600">
      <v-card>
        <v-card-title class="headline">{{ noticeContent.name }}</v-card-title>
        <v-card-subtitle class="text-right">{{ $t('updateDate') }}：{{ new Date(noticeContent.updateTime).toLocaleDateString() }}</v-card-subtitle>
        <v-card-text><v-textarea v-model="noticeContent.description" readonly auto-grow flat solo></v-textarea></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="_blue" outlined text @click="hasDetail = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Db from '@/api/awsDb';

export default {
  name: 'DownloadZone',
  data: () => ({
    notices: [],
    noticeContent: {},
    files: [],
    hasDetail: false,
    categoryDownload: ['doc', 'file'],
  }),
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapGetters('locale', ['locale']),
    ...mapGetters('dbTable', ['permissionId']),
    showNotices() {
      const ary = this.notices.filter((x) => x.locale === this.locale);
      if (!this.isSignIn) {
        return ary.filter((x) => x.loginDisplay !== true);
      }
      if (!this.isDeveloper(this.userAttribute.policy)) {
        return ary.filter((x) => x.developerDisplay !== true);
      }
      return ary;
    },
    noticesCategory() {
      if (this.showNotices.length === 0) return [];
      return Array.from(new Set(this.notices.map((x) => x.category)));
    },
    showDownload() {
      const obj = {};
      const ary = this.files.filter((x) => x.locale === this.locale);
      this.categoryDownload.forEach((category) => {
        if (!this.isSignIn) obj[category] = ary.filter((x) => x.category === category && x.loginDisplay !== true);
        else if (!this.isDeveloper(this.userAttribute.policy)) {
          obj[category] = ary.filter((x) => x.category === category && x.developerDisplay !== true);
        } else obj[category] = ary.filter((x) => x.category === category);
      });
      return obj;
    },
    downloadCategory() {
      return this.categoryDownload.filter((category) => this.showDownload[category].length !== 0);
    },
    downloadSelectItem() {
      const ary = [];
      for (let i = 0; i < this.categoryDownload.length; i += 1) {
        ary.push({ text: this.$i18n.t(this.categoryDownload[i]), value: this.categoryDownload[i] });
      }
      return ary;
    },
  },
  created() {
    this.update();
  },
  methods: {
    isDeveloper(value) {
      if (!value) return false;
      return Object.keys(value).findIndex((x) => x === this.permissionId('launch')) !== -1;
    },
    showDetailHandler(notice) {
      this.hasDetail = true;
      this.noticeContent = notice;
    },
    downloadHandler(filePath) {
      window.open(`${process.env.VUE_APP_S3_URL}${filePath}`);
    },
    downloadCategoryFiles(category) {
      return this.showDownload[category];
    },
    update() {
      Db.scan('smb').then((response) => {
        if (response === undefined) return;
        this.notices = response.filter((x) => x.type === 'notice');
        this.files = response.filter((x) => x.type === 'download');
        if (this.files.length === 0) {
          this.files = [{ category: 'doc' }];
        }
        this.notices.sort((a, b) => b.updateTime - a.updateTime);
      });
    },
    // text2html(str) {
    //   if (!str) {
    //     return '';
    //   }
    //   return str.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    // },
  },
};
</script>

<style scoped>
.dt_bg_blueTrans {
  background-color: rgba(0, 49, 101, 0.75) !important;
}
.dt_bg_transparent {
  background-color: rgba(255, 255, 255, 0.75) !important;
}
.dt_Content {
  word-break: break-all;
}
.card_scroll {
  overflow-y: scroll;
}
</style>
